import { inject, Injectable } from '@angular/core';
import { tap } from 'rxjs';
import { TenantConfiguration } from '../types/tenant-configuration.interface';
import { WINDOW } from '../utils/window.token';
import { TenantService } from './tenant.service';

@Injectable({
  providedIn: 'root',
})
export class InitService {
  public tenantConfig!: TenantConfiguration;
  private tenantService = inject(TenantService);
  private window = inject(WINDOW);

  constructor() {}

  init() {
    let domain = this.window.location.host;
    console.log(`Fetching tenant configuration for domain: ${domain}`);
    
    return this.tenantService
      .getTenantConfigurationsByDomain(domain)
      .pipe(tap((config) => (this.tenantConfig = config)));
  }
}
